import React from "react";
import ComponenteConItemsForm from "./ComponenteConItemsForm";

export default function PuertaForm() {
  return <ComponenteConItemsForm titulo="Puerta" tipo="puerta" />;
}
